<template>
  <div class="detail-properties flex-container flex-column">
    <div class="detail-data-types flex-container flex-row flex-verti-center">
      <span class="select-name">{{ $t('component.type') }}</span>
      <div class="detail-data-types-select flex-item flex-item-grow">
        <el-select v-model="familyType" value-key="id" :placeholder="$t('component.specification')" style="width:100%" @change="changeType">
            <el-option
              v-for="type in familyTypes"
              :key="type.id"
              :label="type.name"
              :value="type"
            />
        </el-select>
      </div>
    </div>
    <div class="detail-data-properties flex-item flex-item-grow flex-container flex-column">
      <el-collapse v-model="active" >
        <el-collapse-item
          v-for="(group,index) in properties"
          v-show="group.parameterValues.length"
          :key="index"
          :title="group.name"
          :name="index"
        >
          <ul>
            <li v-for="property in group.parameterValues" :key="property.id" class="property flex-container">
              <span class="property-name line-no-wrap" :title="property.name">{{ property.name }}</span>
              <span class="property-value line-no-wrap" :title="property.value">{{ property.value || '---' }}</span>
            </li>
          </ul>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    properties: {
      type: Array,
      default() {
        return []
      }
    },
    familyTypes: {
      type: Array,
      default() {
        return []
      }
    },
    currentType: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      familyType: {},
      active: []
    }
  },
  computed: {
    propertiesLength() {
      return this.properties.length
    }

  },
  watch: {
    'currentType.id': {
      handler() {
        this.familyType = { ...this.currentType }
      },
      immediate: true
    },
    propertiesLength: {
      handler(newVal) {
        this.active = Array.from(new Array(newVal).keys())
      },
      immediate: true
    }
  },
  methods: {
    changeType(type) {
      this.$emit('change-type', type)
    }
  }
}
</script>

<style lang="less" scoped>
.detail-properties{
  height: 100%;
  // 检查插件产品详情的样式
  .detail-data-types{
    padding: 15px 8px 17px;
    .select-name{
      color: @theme-grey-1;
      padding-right: 12px;
    }
  }
}
.detail-data-properties{
  height: calc(100% - 64px);
  overflow-y: auto;
  .property{
      margin-top: 8px;
      font-size: 1rem;
      .property-name{
        text-align: right;
        padding-right:16px;
        color: #787A83;
        width: 200px;
      }
      .property-value{
        width: 120px;
        flex-shrink: 0;
        flex-grow: 0;
        text-align: left;
        color: #282833;
      }
    }
}
</style>
